import { Component, ComponentInterface, h } from '@stencil/core';

@Component({
  tag: 'app-header',
  styleUrl: 'style.scss',
  shadow: false,
  scoped: false,
})
export class AppHeader implements ComponentInterface {

  render() {
    return (
      <header class='header'>
        <div class='page-container-inner'>
          <span class='logo'>
              <stencil-route-link url='/' />
          </span>

          <span class='navigation'>
            <navigation-main />
          </span>
        </div>
      </header>
    );
  }
}
